// extracted by mini-css-extract-plugin
export default {"navigate":"Navigate_navigate__E40KI","arrow":"Navigate_arrow__LrwiK","arrow_animation":"Navigate_arrow_animation__fWdAX"};